import { Fab, Tooltip, Zoom } from '@mui/material';
import { WhatsApp } from '@mui/icons-material';
import { motion } from 'framer-motion';

const WhatsAppButton = () => {
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    window.open('https://wa.me/27720100332', '_blank', 'noopener,noreferrer');
  };

  return (
    <Zoom in={true} style={{ transitionDelay: '500ms' }}>
      <Tooltip 
        title="Message John on WhatsApp" 
        placement="left"
        disableFocusListener={false}
        disableHoverListener={false}
        disableTouchListener={false}
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.3 }}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          style={{ 
            position: 'fixed',
            bottom: 30,
            right: 30,
            zIndex: 1300, // MUI's default modal z-index is 1300
          }}
        >
          <Fab
            onClick={handleClick}
            size="large"
            sx={{
              background: '#25D366',
              color: '#fff',
              '&:hover': { 
                background: '#128C7E',
              },
              '&:active': {
                transform: 'scale(0.95)',
              },
              // MUI specific - ensure clickability
              pointerEvents: 'auto',
              cursor: 'pointer',
              boxShadow: '0 4px 15px rgba(37, 211, 102, 0.3)',
            }}
          >
            <WhatsApp sx={{ fontSize: 30 }} />
          </Fab>
        </motion.div>
      </Tooltip>
    </Zoom>
  );
};

export default WhatsAppButton;